import {
  Box,
  CircularProgress,
  CircularProgressProps,
  Fade,
  Typography,
} from '@mui/material';
import React from 'react';

import ProgressIndicator from './ProgressIndicator';

const PageSpinner: React.FC<
  CircularProgressProps & {
    type?: 'throbber' | 'progress';
    text?: string | React.ReactNode;
    position?: 'absolute' | 'relative';
  }
> = ({ text, type = 'throbber', position = 'absolute', ...props }) => {
  const { color, sx, value, ...rest } = props;
  const shown = !value || (!!value && value < 100);

  return (
    <Fade in={shown} timeout={{ exit: 1000 }} unmountOnExit>
      <Box position={position} width={1}>
        {type === 'throbber' ? (
          <CircularProgress
            sx={{
              display: 'block',
              color: color || 'primary.main',
              m: '0 auto',
              mt: 24,
              size: 50,
              ...(sx || {}),
            }}
            {...rest}
          />
        ) : (
          <ProgressIndicator
            sx={{
              display: 'block',
              color: 'secondary.main',
              m: '0 auto',
              mt: 24,
              ...(sx || {}),
            }}
            {...rest}
          />
        )}

        {typeof text === 'string' ? (
          <Typography mt={2} variant="h6" textAlign="center">
            {text}
          </Typography>
        ) : (
          <>{text}</>
        )}
      </Box>
    </Fade>
  );
};

export default PageSpinner;
